import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashedSquareWithEnlargeMagnifyingGlass = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "currentcolor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		fill: "none",
		d: "M6.875 11.874a5 5 0 1 0 10 0 5 5 0 0 0-10 0ZM10 11.874h3.75M11.875 10v3.75M15.41 15.41l3.965 3.964M.625 3.124v-1.25a1.25 1.25 0 0 1 1.25-1.25h1.25M3.125 19.374h-1.25a1.25 1.25 0 0 1-1.25-1.25v-1.25M.625 6.25v2.5M.625 11.25v2.5M19.375 6.25v2.5M6.25.624h2.5M11.25.624h2.5M16.875.624h1.25a1.25 1.25 0 0 1 1.25 1.25v1.25M8.75 19.374h-2.5"
	}));
});
export default SvgDashedSquareWithEnlargeMagnifyingGlass;
